module.exports = __webpack_public_path__ + "assets/b8831c447127ca82aa6c8bdb998244c2.mp3";